import React, { useCallback, useEffect, useState } from 'react';
import { HashRouter, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import Landing from './components/Landing';
import Auth from './components/Auth';
import Onboarding, { Analysis } from './components/Onboarding';
import AppLayout from './components/AppLayout';
import Dashboard from './components/Dashboard';
import { LeadsPage, OpportunityDetail, RecoverablePage } from './components/LeadsPages';
import { Reports, Settings, UploadPage } from './components/ManagementPages';

function Application() {
  const routerNavigate = useNavigate();
  const location = useLocation();
  const [language, setLanguage] = useState('ar');
  const path = location.pathname;
  const navigate = useCallback((route) => routerNavigate(route), [routerNavigate]);

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  }, [language]);

  if (path === '/') return <Landing language={language} setLanguage={setLanguage} navigate={navigate} />;
  if (path === '/signup') return <Auth mode="signup" navigate={navigate} />;
  if (path === '/login') return <Auth mode="login" navigate={navigate} />;
  if (path === '/forgot') return <Auth mode="forgot" navigate={navigate} />;
  if (path === '/onboarding') return <Onboarding navigate={navigate} />;
  if (path === '/analysis') return <Analysis navigate={navigate} />;

  let page = <Dashboard navigate={navigate} language={language} />;
  if (path === '/leads') page = <LeadsPage navigate={navigate} />;
  if (path === '/recoverable') page = <RecoverablePage navigate={navigate} />;
  if (path.startsWith('/opportunity/')) page = <OpportunityDetail id={path.split('/').pop()} navigate={navigate} />;
  if (path === '/reports') page = <Reports />;
  if (path === '/upload') page = <UploadPage navigate={navigate} />;
  if (path === '/settings') page = <Settings />;

  return (
    <AppLayout path={path} navigate={navigate} language={language} setLanguage={setLanguage}>
      {page}
    </AppLayout>
  );
}

export default function App() {
  return (
    <HashRouter>
      <Application />
    </HashRouter>
  );
}